module.exports = __webpack_public_path__ + "img/nikkon_hplogo_3.c35f27e0.jpg";